/** Shared login/register form — works on light and dark desktop panels */
export const authInput =
  'w-full rounded-full border border-surface-200 bg-surface-50 px-4 py-3.5 text-sm text-surface-900 placeholder:text-surface-400 transition-all duration-300 focus:border-brand-400 focus:bg-white focus:outline-none focus:ring-4 focus:ring-brand-500/15 dark:border-surface-600 dark:bg-surface-800 dark:text-white dark:placeholder:text-surface-500 dark:focus:border-brand-400 dark:focus:bg-surface-900 dark:focus:ring-brand-400/25';

export const authPageTitle =
  'mb-2 text-2xl font-extrabold tracking-tight text-surface-900 sm:text-3xl dark:text-white';

export const authPageSubtitle = 'text-sm text-surface-500 dark:text-surface-400';

export const authDividerLine = 'h-px flex-1 bg-surface-200 dark:bg-surface-600';

export const authDividerLabel = 'shrink-0 text-xs font-semibold text-surface-400 dark:text-surface-500';

export const authFooterMuted = 'text-sm text-surface-500 dark:text-surface-400';

export const authLegalMuted = 'text-center text-xs leading-relaxed text-surface-400 dark:text-surface-500';

export const authTextLink =
  'font-bold text-brand-600 transition-colors hover:text-brand-500 dark:text-brand-400 dark:hover:text-brand-300';

export const authInlineLink =
  'text-xs font-semibold text-brand-600 transition-colors hover:text-brand-500 dark:text-brand-400 dark:hover:text-brand-300';

export const authTextLinkSemibold =
  'font-semibold text-brand-600 hover:underline dark:text-brand-400 dark:hover:text-brand-300';

export const authIconButton =
  'text-surface-400 transition-colors hover:text-surface-600 dark:text-surface-500 dark:hover:text-surface-300';
